import { Pipe, PipeTransform } from '@angular/core';
import { Utils, GenericObject } from 'ngx-web-api';

/**
 * Searches for a key/value match in an array of Objects. Example usage :
 * myArrayOfObjects | propInArray : myKey : myValue
 */
@Pipe({
  name: 'propInArray',
  pure: true,
})
export class PropInArrayPipe implements PipeTransform {
  transform(data: GenericObject<any>[], key: string, value: any): boolean {
    return !!data && !!key && !!value && data.some(s => Utils.deepEqual(s[key], value));
  }
}
